<div *ngIf="formGroup" [formGroup]="formGroup" class="formItemsBox">
  <div class="form-item" *ngIf="!unVisibleComp.name">
    <mat-form-field appearance="fill">
      <mat-label>Nom</mat-label>
      <input matInput placeholder="" formControlName="name" />
      <mat-error *ngIf="formGroup.controls.name.hasError('required')"> Nom est <strong>obligatoire</strong> </mat-error>
    </mat-form-field>
  </div>

  <div class="form-item" *ngIf="!unVisibleComp.size">
    <mat-form-field appearance="fill">
      <mat-label>Taille</mat-label>
      <input matInput placeholder="" formControlName="size" type="number" />
      <mat-error *ngIf="formGroup.controls.size.hasError('required')"> Taille est <strong>obligatoire</strong> </mat-error>
    </mat-form-field>
  </div>

  <div class="form-item" *ngIf="!unVisibleComp.hidden"><mat-checkbox formControlName="hidden">Caché</mat-checkbox><br /></div>

  <div class="form-item" *ngIf="!unVisibleComp.docTypes">
    <app-documenttype-form-auto-complete [formArr]="formGroup._docTypes" placeholder="Type de document à filtrer">
    </app-documenttype-form-auto-complete>
  </div>

  <div class="form-item" *ngIf="!unVisibleComp.actTypes">
    <app-acttype-form-auto-complete [formArr]="formGroup._actTypes" placeholder="Types de dossier à filtrer"> </app-acttype-form-auto-complete>
  </div>

  <div class="form-item" *ngIf="!unVisibleComp.value">
    <mat-form-field appearance="fill">
      <mat-label>value</mat-label>
      <input matInput placeholder="" formControlName="value" />
      <mat-error *ngIf="formGroup.controls.value.hasError('required')"> value est <strong>obligatoire</strong> </mat-error>
    </mat-form-field>
  </div>

  <div class="form-item" *ngIf="!unVisibleComp.target">
    <mat-form-field appearance="fill">
      <mat-label>Cible</mat-label>

      <mat-select placeholder="Select" formControlName="target">
        <mat-option value="subjects">subjects</mat-option>

        <mat-option value="contractors">contractors</mat-option>

        <mat-option value="both">both</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>
